import type { ReactNode } from 'react';

export function PageHeader({ eyebrow, title, subtitle, actions }: { eyebrow?: string; title: string; subtitle?: string; actions?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
      <div>
        {eyebrow && <div className="text-[11px] font-bold tracking-wide text-teal">{eyebrow}</div>}
        <h1 className="mt-1.5 mb-2 text-2xl font-bold">{title}</h1>
        {subtitle && <p className="text-[13px] text-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex w-full flex-wrap items-center gap-2 md:w-auto">{actions}</div>}
    </div>
  );
}
